export default "__VITE_ASSET__8784d09f__"